import React, {useRef, useEffect} from 'react';
import {injectIntl} from 'react-intl';
import JobCard from '@Components/JobCard';

const RelatedJobs = (
    {
      intl,
      relatedJobsData,
      configurations,
      title,
      listColorClass = 'bg-brand--off-white',
      cardColorClass = 'bg-brand--white',
      viewAllLinkText,
      seeAllUrl,
    },
) => {
  const carousel = useRef(null);
  const heading = title ? title : 'RelatedJobs.Title';
  const seeAllTitle = viewAllLinkText ?? 'RelatedJobs.Link';
  const url = seeAllUrl ? seeAllUrl : relatedJobsData.searchUrl;
  const renderJobs = () => {
    let jobs = [];
    if (relatedJobsData && relatedJobsData.results) {
      jobs = relatedJobsData.results.map((job, key) => (
        <JobCard key={key} jobData={job} backgroundColorClass={cardColorClass} configurations={configurations}/>
      ));
    }
    return jobs;
  };

  useEffect(() => {
    // Refresh slick slider on relatedJobsData update.
    if (
      carousel.current && carousel.current.classList.contains('slick-initialized') &&
      carousel.current.slick && typeof carousel.current.slick.refresh === 'function'
    ) {
      carousel.current.slick.refresh();
    }
  }, [relatedJobsData]);

  return (
    <div className={`block block--s ${listColorClass}`}>
      <div className="block__wrapper block__wrapper--stacked wrapper">
        <div className="block__header block__header--split block__header--l">
          <h2 className="block__title">{intl.formatMessage({id: heading})}</h2>
          <a href={url} className="block__more-link">{intl.formatMessage({id: seeAllTitle})}</a>
        </div>
        <div className="block__content block__content--full-on-s block__content--full-on-m">
          <div className="cards">
            <ul
              ref={carousel}
              className="cards__list cards__list--format-carousel carousel--on-s carousel--on-m"
              data-rs-carousel="cards"
            >
              {renderJobs()}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(RelatedJobs);
